import React from "react";
import { Divider, ListItemIcon, Menu, MenuItem, Stack } from "@mui/material";
import AccountMenuLink from "./AccountMenuLink";
import {
  AdminPanelSettings,
  Logout,
  Person,
  SpaceDashboard,
} from "@mui/icons-material";

const AccountMenu = ({
  anchorEl,
  onMenuClose,
  isAdminPermission,
  onSignoutClicked,
  onLinkClicked,
  ...props
}) => {
  const open = Boolean(anchorEl);

  return (
    <Menu
      id="account-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onMenuClose}
    >
      <Stack padding={1} {...props}>
        <AccountMenuLink
          icon={<SpaceDashboard fontSize="small" />}
          label="Dashboard"
          path="/dashboard"
          onLinkClicked={onLinkClicked}
        />
        <AccountMenuLink
          icon={<Person fontSize="small" />}
          label="Profile"
          path="/profile"
          onLinkClicked={onLinkClicked}
        />
        {isAdminPermission && (
          <AccountMenuLink
            icon={<AdminPanelSettings fontSize="small" />}
            label="Admin"
            path="/admin"
            onLinkClicked={onLinkClicked}
          />
        )}
        <Divider />
        <MenuItem onClick={onSignoutClicked}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Sign out
        </MenuItem>
      </Stack>
    </Menu>
  );
};
export default AccountMenu;
